import React, { Dispatch } from "react";
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonGroup,
  Button,
  ButtonDropdown
} from "reactstrap";
import { connect } from "react-redux";
import { IAppState, LoadingDisplay, LoadingState } from "../../../../Common";
import { Topic } from "../../../../Topic/Models/Topic";

type Props = {
  value?: Topic;
  onSelected: (app: Topic) => void;
};

type State = {
  isOpen: boolean;
};

type StateProps = {
  topics: Topic[];
  topicsLoadingState: LoadingState;
};

const mapStateToProps = (state: IAppState): StateProps => ({
  topics: state.app.topics,
  topicsLoadingState: state.app.topicsLoadingState
});

class FeedbackTopicDropdown extends React.Component<Props & StateProps, State> {
  constructor(props: Props & StateProps) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  onToggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  render() {
    const styles: React.CSSProperties = {
      backgroundColor: "white",
      color: "black",
      opacity: "initial"
    };

    return (
      <ButtonGroup>
        <Button disabled style={styles}>
          Topic
        </Button>
        <ButtonDropdown isOpen={this.state.isOpen} toggle={this.onToggle}>
          {this.props.topicsLoadingState.isLoading ? (
            <LoadingDisplay />
          ) : (
            <>
              <DropdownToggle caret>
                {this.props.value ? this.props.value.name : "Select a topic"}
              </DropdownToggle>
              <DropdownMenu>
                {this.props.topics.map(topic => (
                  <DropdownItem key={topic.code} onClick={() => this.props.onSelected(topic)}>
                    {topic.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </>
          )}
        </ButtonDropdown>
      </ButtonGroup>
    );
  }
}

export default connect(mapStateToProps)(FeedbackTopicDropdown);
